import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, branch, lifecycle, renderComponent } from 'recompose';

import authHOC from '../Components/AuthHOC';
import Spinner from '../Components/Spinner';
import ToolsView from './Components/ToolsView';

import {
  getClientBackGroundRequest,
  toggleSaveEditPopup,
  toggleUserDashboard,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies } from '../redux/reducers/login';
import {
  getUserProgramsFullRequest,
  selectUserPrograms,
  selectUserModule,
} from '../redux/reducers/userProgramsFull';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { toolsListRequest } from '../redux/reducers/contentList';
import { dropdownsRequest } from '../redux/reducers/dropdowns';

const Tools = ({ view }) => <ToolsView view={view} />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  contentList: state.contentListReducer
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  getClientBackGroundRequest: () => dispatch(getClientBackGroundRequest()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  toggleRefererPage: moduleId => dispatch(toggleRefererPage(moduleId)),
  getToolsList: () => dispatch(toolsListRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        savedVersions,
        toggleSaveEditPopup,
        userProgramsFull,
        getUserProgramsFullRequest,
        toggleUserDashboard,
        toggleRefererPage,
        contentList,
        getToolsList
      } = this.props;
      const isLoggedIn = loginReducer.user && loginReducer.user.userId;

     
      if (isLoggedIn && contentList.isFetched === false) {
        getToolsList();
      }
      if (savedVersions.pathToSaveVersion !== null) {
        //toggleSaveEditPopup(true);
      }
      toggleUserDashboard(false);
    },
    componentWillReceiveProps(nextProps) {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        userProgramsFull,
        getUserProgramsFullRequest,
        selectUserPrograms,
        contentList,
        getToolsList
        // selectUserModule,
      } = nextProps;
      const isLoggedIn = loginReducer.user && loginReducer.user.userId;
     
      if (
        isLoggedIn &&
        contentList.isFetched === false &&
        contentList.fetching === false
      ) {
        getToolsList();
      }
      // if (userProgramsFull.isFetched && userProgramsFull.selectedProgramId === null) {
      //   selectUserPrograms(userProgramsFull.programs.programs[0].programId);
      //   // selectUserModule(userProgramsFull.programs.programs[0].modules[0].moduleId);
      // }
    },
  }),
 
)(Tools);

Tools.propTypes = {
  view: PropTypes.instanceOf(Object),
};
